export default "__VITE_ASSET__D7G$Jg0S__"